import HeaderDesktop from "@Components/Header/HeaderDesktop";
import FooterDesktop from "@Components/FooterV2/FooterDesktop";
import { Helmet } from "react-helmet";
import wrapperHOC from "@Utils/wrapperHOC";
import PersonalInfoCollection from "../components/PersonalInfoSharingListContainer/PersonalInfoSharingListContainer";

const PersonalInfoSharingList = () => (
  <div>
    <Helmet title="Personal Information Sharing List | Amber" />
    <HeaderDesktop hideAppBanner />
    <PersonalInfoCollection />
    <FooterDesktop />
  </div>
);

export default wrapperHOC(PersonalInfoSharingList, {
  componentName: "PersonalInfoSharingListDesktop",
  showForChina: true,
});
